import { cn } from '../../utils/cn';
import { ViewType } from './types';

const viewStyles = {
  main: {
    button: 'p-2 rounded-lg',
    menu: 'w-64',
  },
  sidepanel: {
    button: 'p-1.5 rounded-md',
    menu: 'w-48',
  },
  fullscreen: {
    button: 'p-2 rounded-lg',
    menu: 'w-64',
  },
} as const;

export const getSortMenuStyles = (view: ViewType, variant: 'default' | 'compact' = 'default') => {
  const baseStyles = viewStyles[view];

  return {
    container: cn(
      // z-index is applied inline (Z_LAYERS.CONTENT) by the component — a
      // runtime-interpolated Tailwind z- class generates no CSS (#110).
      'relative isolate',
      variant === 'compact' && 'max-w-none'
    ),

    button: cn(
      baseStyles.button,
      'flex items-center gap-1',
      'transition-colors duration-200',
      'focus:outline-none focus:ring-2'
    ),

    menu: cn(
      // z-index (Z_LAYERS.DROPDOWN) is applied inline by the component; a
      // runtime-interpolated Tailwind z- class here produced no CSS (#110).
      'fixed',
      baseStyles.menu,
      'rounded-xl',
      'shadow-lg focus:outline-none',
      'backdrop-filter backdrop-blur-sm border',
      'transition-all duration-200 ease-out',
      'animate-in slide-in-from-top-2 zoom-in-98'
    ),

    backdrop: cn(
      // z-index is applied inline by the component (see the backdrop div).
      'fixed inset-0',
      'bg-transparent cursor-default',
      'animate-in fade-in-0'
    ),

    section: cn('p-2 first:border-b'),

    sectionHeader: cn('flex items-center space-x-2 px-2 py-1', 'text-sm'),

    optionsList: cn('mt-1 space-y-1'),

    option: (_isActive: boolean) =>
      cn(
        'w-full px-3 py-1 text-left text-sm rounded-md',
        'flex items-center space-x-2',
        'transition-colors duration-200'
      ),

    icon: cn('w-4 h-4'),
  };
};
